

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Project.Validator.js"

class ProjectAPI {


/*
undefinedPOST http://localhost:3000/projects/create
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{
    "name" : "Xây dựng ống nước Sông Đà",
    "address":"Hà Đông, Hà Nội",
    "district":"Quận Hà Đông",
    "city":"Thành Phố Hà Nội",
    "country":"Việt Nam",
    "projectType":"Hotel",
    "projectSubType":"5 star"
}


*/


  create = async (data) => {
    const validator = Validator.VALIDATION_PROJECTS_CREATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/projects/create", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


GET http://localhost:3000/projects/detail/522911722487
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw


*/


  detail = async (id, data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.get(HOST + "/projects/detail/" + id, data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/projects/update/522911722487
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "name" : "Xây dựng ống nước Sông Đà update",
    "documents":[{"id":"file-1","url":"Duong dan toi file"}],
    "listImages":["url file anh 1","url file anh 2"],
    "minBudget":1000000000,
    "maxBudget":10000000000,
    "minStartTime":"2018-03-25T00:10:23.754Z",
    "maxStartTime":"2018-04-25T00:10:23.754Z",
    "minFinishTime":"2019-03-25T00:10:23.754Z",
     "maxFinishTime":"2019-04-25T00:10:23.754Z"
}


*/

  update = async (id, data) => {
    const validator = Validator.VALIDATION_PROJECTS_UPDATE;

    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        console.log(result.error);
        return { validateError: result.error.details[0].message }
      }
    }

    const result = await Request.post(HOST + `/projects/update/${id}`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };



/*

POST http://localhost:3000/projects/search
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{
    "name" : "xây dựng",
    "orderBy":"updatedAt",
    "orderType":"DESC",
//    "minBudget":1000000000,
    "filterFollow":true
}


*/


  search = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/projects/search", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/projects/approve
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "id":"522911722487",
    "approved" : true
}

*/


  approve = async (data) => {
    const validator = Validator.VALIDATION_APPROVED_PROJECT;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/projects/approve", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/projects/adminList
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{
    "name" : "xây dựng",
    "orderBy":"updatedAt",
    "orderType":"DESC",
    "approved":false
}


*/


  adminList = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/projects/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*

*/
  deactive = async (data) => {
    const validator = Validator.VALIDATION_DEACTIVE_PROJECT;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/projects/deactive", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  adminListAnswers = async (data) => {
    const validator = false; // change this to real variable
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/projects/adminListAnswers", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };
}
export default new ProjectAPI();



// WEBPACK FOOTER //
// ./src/services/project/Project.API.js